export const TYPE = ['@type'];
export const FALLBACK = ['fallback'];
export const USER_IDS = ['userIds'];
export const TEAM_IDS = ['teamIds'];
export const CUSTOM_CHAT_NAME = ['customChatName'];
export const COMPANY_LOGO = ['companyLogoUrl'];
export const USE_CUSTOM_BRANDING_ALIAS = ['useCustomBrandingAsAgentAlias'];